import { render, staticRenderFns } from "./TaxaTempo.vue?vue&type=template&id=2cff67dc&scoped=true"
import script from "./TaxaTempo.vue?vue&type=script&lang=js"
export * from "./TaxaTempo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff67dc",
  null
  
)

export default component.exports